import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    formData: {
      l1: '',
      l2: '',
      l3: '',
      country: '',
    },
    searchString: '',
    pageNumber: 0,
  },
  previouslySelectedRow: null,
}

export const shouldCostLibraryFiltersSlice = createSlice({
  name: 'sku-filters',
  initialState,
  reducers: {
    setLibraryFilterValues: (state, action) => {
      state.filters = action.payload
    },
    clearLibraryFilters: () => initialState,
    setPreviouslySelectedRow: (state, action) => {
      state.previouslySelectedRow = action.payload
    },
  },
})

export const { setLibraryFilterValues, clearLibraryFilters, setPreviouslySelectedRow } =
  shouldCostLibraryFiltersSlice.actions

export default shouldCostLibraryFiltersSlice.reducer
